import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import './Admin.css';
import ConfirmationModal from '../../components/support/ConfirmationModal';
import EditDiscountModal from '../../components/admin/EditDiscountModal'; // Yeni modal
import DiscountUsageModal from '../../components/admin/DiscountUsageModal';
const API_URL = process.env.REACT_APP_API_URL;

const DiscountManagementPage = () => {
  const { t } = useTranslation();
  const { token } = useAuth();
  
  const [discounts, setDiscounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDiscount, setSelectedDiscount] = useState(null); // Düzenlenecek veya eklenecek indirim
  const [discountToDelete, setDiscountToDelete] = useState(null);
const [isUsageModalOpen, setIsUsageModalOpen] = useState(false);
    const [selectedDiscountForUsage, setSelectedDiscountForUsage] = useState(null);
  const fetchDiscounts = useCallback(async () => {
    if (!token) return;
    try {
      setLoading(true); setError('');
      const response = await fetch(`${API_URL}/api/admin/discounts`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error(t('error_fetch_discounts'));
      const data = await response.json();
      setDiscounts(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [token, t]);

  useEffect(() => {
    fetchDiscounts();
  }, [fetchDiscounts]);
  
  const handleOpenModal = (discount = null) => {
    setSelectedDiscount(discount); // Eğer discount null ise, "yeni ekle" modudur.
    setIsModalOpen(true);
  };
  
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedDiscount(null);
  };

  const handleSaveDiscount = () => {
    handleCloseModal();
    fetchDiscounts(); // Liste yenile
  };

  const openDeleteModal = (discount) => {
    setDiscountToDelete(discount);
  };

  const handleDeleteDiscount = async () => {
    if (!discountToDelete) return;
    try {
        const response = await fetch(`${API_URL}/api/admin/discounts/${discountToDelete.id}`, {
            method: 'DELETE',
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) throw new Error(t('error_delete_discount'));
        alert(t('success_discount_deleted'));
        setDiscountToDelete(null);
        fetchDiscounts();
    } catch (err) {
        alert(err.message);
        setDiscountToDelete(null);
    }
  };
  
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString();
  };

 const openUsageModal = (discount) => {
        setSelectedDiscountForUsage(discount);
        setIsUsageModalOpen(true);
    };

    const closeUsageModal = () => {
        setIsUsageModalOpen(false);
        setSelectedDiscountForUsage(null);
    };

  return (
    <>
      <div className="page-container admin-dashboard">
        <div className="page-header modern">
            <h1>{t('discount_management')}</h1>
            <button className="add-user-btn-modern" onClick={() => handleOpenModal()}>
                <i className="fas fa-plus"></i> {t('add_new_discount')}
            </button>
        </div>
        
        <div className="admin-table-container">
          <table className="admin-table">
            <thead>
              <tr>
                <th>{t('code')}</th>
                <th>{t('description')}</th>
                <th>{t('type')}</th>
                <th>{t('value')}</th>
				<th>{t('usage')}</th>
                <th>{t('validity_dates')}</th>
                <th>{t('status')}</th>
                <th>{t('actions')}</th>
              </tr>
            </thead>
            <tbody>
              {loading && <tr><td colSpan="8" className="table-row-message">{t('loading_discounts')}</td></tr>}
              {error && <tr><td colSpan="8" className="table-row-message error">{error}</td></tr>}
              {!loading && discounts.map(discount => (
                <tr key={discount.id}>
                  <td>{discount.code || '-'}</td>
                  <td>{discount.description}</td>
                  <td>{t(`discount_type_${discount.type}`)}</td>
                  <td>{discount.value_type === 'percent' ? `${discount.value}%` : `${discount.value} TL`}</td>
				<td>
                                    {/* KULLANIM SAYISINI TIKLANABİLİR YAP */}
                                    <button 
                                        className="usage-link-button" 
                                        onClick={() => openUsageModal(discount)}
                                        disabled={(discount.current_usage || 0) === 0}
                                    >
                                        {discount.current_usage || 0} / {discount.usage_limit || t('unlimited')}
                                    </button>
                                </td>
                  <td>{formatDate(discount.start_date)} - {formatDate(discount.end_date)}</td>
                  <td>
                    <span className={`status-badge ${discount.is_active ? 'status-active' : 'status-inactive'}`}>
                        {discount.is_active ? t('active') : t('inactive')}
                    </span>
                  </td>
                  <td>
                    <div className="action-buttons">
                      <button className="action-btn edit" onClick={() => handleOpenModal(discount)}><i className="fas fa-pencil-alt"></i> {t('edit')}</button>
                      <button className="action-btn delete" onClick={() => openDeleteModal(discount)}><i className="fas fa-trash-alt"></i> {t('delete')}</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      
      {isModalOpen && (
          <EditDiscountModal 
            isOpen={isModalOpen} 
            onClose={handleCloseModal} 
            onSave={handleSaveDiscount}
            discount={selectedDiscount}
          />
      )}

      <ConfirmationModal 
        isOpen={!!discountToDelete} 
        onClose={() => setDiscountToDelete(null)} 
        onConfirm={handleDeleteDiscount} 
        title={t('confirm_delete_discount_title')} 
        message={t('confirm_delete_discount_message', { description: discountToDelete?.description })} 
      />
    {isUsageModalOpen && (
                <DiscountUsageModal
                    isOpen={isUsageModalOpen}
                    onClose={closeUsageModal}
                    discount={selectedDiscountForUsage}
                />
            )}
        </>
  );
};

export default DiscountManagementPage;